import {createSelector} from 'reselect';
import {isShippingToChinaWithTaxEnabled} from './DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import getIsMobileNumberField from './getIsMobileNumberField';

export const getIsMobileNumber = createSelector(
  [isShippingToChinaWithTaxEnabled, getIsMobileNumberField],
  (shippingToChinaWithTax, isMobileNumberField) => shippingToChinaWithTax || isMobileNumberField,
);
